import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getMetaData, setIsAgreedtoTerms } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const metaDataService = createAsyncThunk(
    'metaDataService', getMetaData
)
export const setIsAgreedtoTermsService = createAsyncThunk(
    'setIsAgreedtoTermsService', setIsAgreedtoTerms
)
const initialState = {
    sendOtpStatus:false,
    TermsOfUsePopup:false,
    access_token:'',
    refresh_token:'',
    userID:'',
    Email:'',
    value: {
        EmailAddress: "--",
        PortalUserID: "--",
        EIN:'--'
    },
    isLoggedin: false,
    isPreviousSessionActive: false,
    FirstName: "",
    LastName: "",
    PhoneNumber: "",

}

const metaDataSlice = createSlice({
    name: 'metaDataService',
    initialState,
    reducers: {
        resetMetaData: (state) => {
            state.loader = false
        },
        resetTermsOfUsePopup: (state,action)=>{
            state.TermsOfUsePopup=action.payload
        },
        resetSendOtpStatus: (state,action)=>{
            state.sendOtpStatus=action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(metaDataService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(metaDataService.fulfilled, (state, action) => {
                    if(action?.payload?.res?.status){
                        state.portalID=action.payload?.res?.metadata?.PortalUserID
                        state.IsAgreedtoTerms = typeof action.payload?.res?.metadata?.IsAgreedtoTerms != "undefined" || action.payload?.res?.metadata?.IsAgreedtoTerms != '' || action.payload?.res?.metadata?.IsAgreedtoTerms == true ? action.payload?.res?.metadata?.IsAgreedtoTerms : false;
                    }
                state.loader = false
            })
            .addCase(metaDataService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
            .addCase(setIsAgreedtoTermsService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(setIsAgreedtoTermsService.fulfilled, (state, action) => {
                state.IsAgreedtoTerms = action.payload.metaData.metadata.IsAgreedtoTerms ;
                state.TermsOfUsePopup = action.payload.metaData.metadata.IsAgreedtoTerms ;
                state.loader = false
            })
            .addCase(setIsAgreedtoTermsService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetMetaData ,resetIsAgreeflages,resetTermsOfUsePopup,resetSendOtpStatus} = metaDataSlice.actions

export default metaDataSlice.reducer